import React from 'react';
import { Phone } from 'lucide-react';
import { contactInfo } from '../mockData';

const CTA = () => {
    return (
        <section className="py-16 md:py-24 bg-gradient-to-br from-blue-600 via-blue-700 to-blue-800 text-white relative overflow-hidden">
            {/* Background Pattern */}
            <div className="absolute inset-0 opacity-10">
                <div className="absolute inset-0" style={{
                    backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
                    backgroundSize: '30px 30px'
                }}></div>
            </div>

            <div className="container mx-auto px-4 relative z-10">
                <div className="max-w-3xl mx-auto text-center">
                    <h2 className="text-3xl md:text-5xl font-bold mb-6">
                        Hemen Bize Ulaş
                    </h2>
                    <p className="text-xl md:text-2xl mb-8 text-blue-100">
                        Fiyat Öğren!
                    </p>
                    <p className="text-lg mb-10 text-blue-50 max-w-2xl mx-auto">
                        Aracınızın far ve stopları için profesyonel çözümler. Hemen bizi arayın, ücretsiz fiyat teklifi alın!
                    </p>
                    <a
                        href={`tel:${contactInfo.phone}`}
                        className="inline-flex items-center space-x-3 bg-white text-blue-600 px-10 py-5 rounded-full hover:bg-gray-100 transition-all hover:scale-110 shadow-2xl text-xl font-bold"
                    >
                        <Phone size={28} />
                        <span>{contactInfo.phone}</span>
                    </a>
                    <p className="mt-6 text-blue-100">
                        Pazartesi - Cumartesi: 09:00 - 18:00
                    </p>
                </div>
            </div>
        </section>
    );
};

export default CTA;
